import { render, staticRenderFns } from "./JobAttributesEditor.vue?vue&type=template&id=6b4609be"
import script from "./JobAttributesEditor.vue?vue&type=script&lang=ts"
export * from "./JobAttributesEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports